










import { Vue, Component, Prop } from "vue-property-decorator";
import { PrettyPictureLayerModule } from "./";
import { FrameStore } from "@/modules/base";
import ParamsWindow from "./ParamsWindow.vue";
import { defaultParams } from '@/modules/layers/PrettyPictureLayer/defaultParams';
import { store } from '@/store';
import { EquatorialCoord } from '@hscmap/angle';
import * as easing from '@hscmap/easing'

@Component({
  components: { ParamsWindow },
})
export default class extends Vue {
  @Prop({ required: true })
  module!: PrettyPictureLayerModule

  @Prop({ required: true })
  frameStore!: FrameStore<typeof PrettyPictureLayerModule>

  get params() {
    return this.frameStore.params
  }

  get paramsWindow() {
    return this.frameStore.paramsWindow
  }

  reset(key: keyof ReturnType<typeof defaultParams>) {
    return () => {
      this.params[key] = defaultParams()[key]
    }
  }

  goThere(key: keyof ReturnType<typeof defaultParams>) {
    return () => {
      const view = this.params[key].view
      const { a, d } = view
      const coord = EquatorialCoord.fromRad(a, d)
      store.currentGlobe().viewFactory.jumpTo(view, { coord, easingFunction: easing.slowStartStop4, duration: 4000 })
    }
  }
}
